import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Shield, Database } from 'lucide-react';
import { IntelligenceLayout } from './IntelligenceLayout';
import ExclusionListManager from './ExclusionListManager';
import CompanyEnrichmentOverrides from './CompanyEnrichmentOverrides';

const TABS = [
  { key: 'exclusion-lists', label: 'Exclusion Lists', icon: Shield, Component: ExclusionListManager },
  { key: 'enrichment-overrides', label: 'Enrichment Overrides', icon: Database, Component: CompanyEnrichmentOverrides },
];

const DEFAULT_TAB = 'exclusion-lists';

export default function AdminSettingsHub() {
  const [searchParams, setSearchParams] = useSearchParams();
  const requestedTab = searchParams.get('tab');
  const [activeTab, setActiveTab] = useState(
    TABS.some(t => t.key === requestedTab) ? requestedTab : DEFAULT_TAB
  );

  const handleTabClick = (key) => {
    setActiveTab(key);
    setSearchParams({ tab: key });
  };

  const ActiveComponent = TABS.find(t => t.key === activeTab)?.Component || ExclusionListManager;

  return (
    <IntelligenceLayout title="Admin / Settings">
      <div className="border-b border-gray-200 bg-white px-6 pt-4 sticky top-0 z-10" data-testid="admin-settings-hub-tabs">
        <div className="flex items-center gap-1 overflow-x-auto">
          {TABS.map(tab => (
            <button
              key={tab.key}
              onClick={() => handleTabClick(tab.key)}
              data-testid={`admin-settings-tab-${tab.key}`}
              className={`flex items-center gap-1.5 px-3.5 py-2.5 text-sm font-medium rounded-t-lg border-b-2 whitespace-nowrap transition-colors ${
                activeTab === tab.key
                  ? 'text-[#0A1F44] border-[#D4AF37] bg-[#fdf9ef]'
                  : 'text-gray-500 border-transparent hover:text-[#0A1F44] hover:bg-gray-50'
              }`}
            >
              <tab.icon className="h-3.5 w-3.5" />
              {tab.label}
            </button>
          ))}
        </div>
      </div>
      <ActiveComponent embedded />
    </IntelligenceLayout>
  );
}
